import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { mySitesQuery } from '@/queries/my-sites.query'

// L'accès OuiSense est déjà garanti par le layout /_dashboard/admin (isOuisenseUser -> notFound).
export const Route = createFileRoute('/_dashboard/admin/heat-curve-default/')({
  loader({ context }) {
    return context.queryClient.ensureQueryData(mySitesQuery)
  },
  pendingComponent: PendingComponent,
})
